export default __webpack_public_path__ + "static/media/emoji.6931cd62.svg";